<template>
  <div>
    <van-nav-bar fixed title="订单提交成功" left-arrow @click-left="goBack"/>
    <div class="v_mainBox">
      <div class="van-lin1">
        <i class="van-icon van-icon-certificate"></i>
        <p>订单提交成功</p>
      </div>

      <div class="van_xuH">
        <div class="van_title"><span>您的检车订单号：</span><span class="van-color">{{ orderInfo.orderId }}</span></div>
      </div>
      <div class="van_carType">
        <div class="van_title">您提交的订单信息：</div>
        <div class="van_type">
          <span class="van_t">车检站：</span>
          <span class="van_in">{{ orderInfo.carInspectionStation }}</span>
        </div>
        <div class="van_type">
          <span class="van_t">车牌号：</span>
          <span class="van_in">{{ orderInfo.carInspectionVehicleLicenseEntity.plateNo }}</span>
        </div>
        <div class="van_type">
          <span class="van_t">送检形式：</span>
          <span class="van_in">{{ orderInfo.reservationType }}</span>
        </div>
        <div class="van_type">
          <span class="van_t">预约日期：</span>
          <span class="van_in">{{ orderInfo.appointment }}</span>
        </div>
        <div class="van_type">
          <span class="van_t">车辆识别码：</span>
          <span class="van_in">{{ orderInfo.carInspectionVehicleLicenseEntity.vin }}</span>
        </div>
      </div>

      <div class="van_bord">
        <div class="van_tbody">
          <div class="van_title">费用信息：</div>
          <div class="line" v-for="item in reservationPrice" :key="item.id">
            <span class="left">{{ item.label }}</span>
            <span class="right">{{ item.value }}元</span>
          </div>
        </div>

        <div class="van_price">
          <div class="line">
            <span class="left">合计金额</span>
            <span class="right">{{ totlaPrice }}元</span>
          </div>
        </div>

<!--        <div class="van_price">
          <div class="line">
            <span class="wexss">温馨提示：实付金额请到店付款</span>
          </div>
        </div>-->
      </div>

      <div class="van-botom">
        <div class="van_notes">
          <div class="van_title">温馨提示：</div>
          <p>1.请保持手机畅通，有任何问题我们将与您联系。</p>
          <p>2.车辆检测费{{vehicleFee}}元为一次性检测费用，如检测不合格需要重检所产生的费用需客户另行支付。</p>
        </div>
      </div>

      <!-- 提交 -->
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="orderInfor">我已知晓</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import carInspectionOrder from "@/api/carInspectionOrder";
// import dictApi from "@/api/dictApi";

export default {
  name: "",
  data() {
    return {
      id: null,
      orderInfo: {'carInspectionVehicleLicenseEntity': {'plateNo': null}},
      reservationPrice: [],
      totlaPrice: 0,
      vehicleFee: 0
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getOrderInfo()
    // this.getReservationPrice()
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 获取订单信息
     */
    getOrderInfo() {
      carInspectionOrder.byId({'id': this.id}).then(res => {
        this.orderInfo = {}
        this.orderInfo = Object.assign({}, res)

        let fee = {}
        let fee2 = {}
        let fee3 = {}
        if(res.reservationType == '上门代检'){
          fee.label = '检车费'
          fee.value = res.vehicleFee
          fee2.label = '代检服务费'
          fee2.value = res.inspectionServiceFee
          fee3.label = '上门取还车费'
          fee3.value = res.doorServiceFee
          this.reservationPrice.push(fee3)
        }else if(res.reservationType == '到站代检'){
          fee.label = '检车费'
          fee.value = res.vehicleFee
          fee2.label = '代检服务费'
          fee2.value = res.inspectionServiceFee
        }else{
          fee.label = '检车费'
          fee.value = res.vehicleFee
          fee2.label = '平台预约服务费'
          fee2.value = res.platFee
        }
        this.reservationPrice.push(fee)
        this.reservationPrice.push(fee2)
        this.totlaPrice = res.totalCost
        this.vehicleFee = res.vehicleFee
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
/*    getReservationPrice() {
      this.reservationPrice.length = 0
      this.totlaPrice = 0
      dictApi.getReservationPrice().then(res => {
        this.reservationPrice = res.content
        for (let i = 0; i < res.content.length; i++) {
          this.totlaPrice = this.totlaPrice + parseFloat(res.content[i].value)
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },*/

    /**
     * 跳转订单详情
     */
    orderInfor() {
      this.$router.push({
        path: '/orderInfor',
        query: {id: this.id}
      })
    },
  }
}
</script>

<style scoped>
.v_mainBox {
  width: 100%;
  padding-top: 45px;
}

.van-lin1 {
  width: 60%;
  margin: auto;
  height: 100px;
  overflow: hidden;
}

.van-lin1 i {
  font-size: 50px;
  display: block;
  color: #3778d0;
  margin-top: 14px;
  text-align: center;
}

.van-lin1 p {
  text-align: center;
  color: #3778d0;
}

.van_xuH {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  background-color: #fff;
  margin-top: 20px;
  border-top: 5px solid #eee;
  border-bottom: 5px solid #eee;
}

.van_xuH .van_title {
  width: 90%;
  margin: auto;
  height: auto;
  line-height: 45px;
}

.van_carType {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  background-color: #fff;
  padding-bottom: 15px;
  border-bottom: 5px solid #eee;
}

.van_carType .van_title {
  width: 100%;
  padding: 0 15px;
  height: 40px;
  line-height: 45px;
}

.van_carType .van_type {
  width: 100%;
  padding: 0 15px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}

.van_carType .van_type .van_t {
  width: 27%;
  height: 100%;
  display: inline-block;
}

.van_carType .van_type .van_in {
  color: #3778d0;
}

.van_bord {
  border-bottom: 5px solid #eee;
}

.van_tbody {
  width: 90%;
  margin: auto;
  height: auto;
  display: block;
  background-color: #fff;
}

.van_tbody .van_title {
  height: 40px;
  line-height: 50px;
}

.van_tbody .line {
  width: 100%;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  border-bottom: 1px solid #eee;
}

.van_tbody .line .left{
  width: 75%;
}
.van_tbody .line .right{
  width:25%;
}

.van_tbody .line .left, .van_tbody .line .right {
  float: left;
  font-size: 14px;
}

.van_tbody .line .right {
  text-align: right;
  color: #3778d0;
}

.van_price {
  width: 90%;
  margin: auto;
  background-color: #fff;
  height: auto;
}

.van_price .line {
  width: 100%;
  height: 45px;
  line-height: 45px;
}

.van_price .line .left, .van_price .line .right {
  width: 50%;
  float: left;
  font-size: 16px;
}

.van_price .line .right {
  text-align: right;
  color: #3778d0;
}

.van-botom {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: 20px
}

.van_notes {
  width: 90%;
  margin: 10px auto;
  display: block;
  overflow: hidden;
}

.van_notes .van_title {
  height: 40px;
  line-height: 50px;
}

.van_notes p {
  margin: 0;
  padding: 0;
  line-height: 25px;
  font-size: 14px;
}

/* 底部按钮 */
.van_bottomBack {
  width: 100%;
  height: 60px;
  bottom: 0;
  position: fixed;
  background: #fff;
  z-index: 100;
}

.van_save_botton {
  width: 80%;
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 10px;
  left: 10%;
  background: #3778d0;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  border-radius: 20px;
}

.van-button--info {
  background-color: #3778d0 !important;
  border: 1px solid #3778d0 !important;
  color: #fff !important;
  margin-top: 10% !important;
}

.van-color {
  color: #3778d0
}

.wexss{font-size: 14px;color:#e01818}
</style>
